// SPDX-License-Identifier: AGPL-3.0-or-later

import * as AccessibilityCommands from '@app/features/accessibility/commands/AccessibilityCommands';
import Accessibility, {HdrDisplayMode} from '@app/features/accessibility/state/Accessibility';
import type {RadioOption} from '@app/features/ui/radio_group/RadioGroup';
import {RadioGroup} from '@app/features/ui/radio_group/RadioGroup';
import MobileLayout from '@app/features/ui/state/MobileLayout';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';
export function shouldShowHdrSettings(): boolean {
	return !MobileLayout.isMobileLayout();
}
export const HdrTabContent: React.FC = observer(() => {
	const {t} = useLingui();
	const hdrDisplayMode = Accessibility.hdrDisplayMode;
	const hdrOptions: ReadonlyArray<RadioOption<HdrDisplayMode>> = [
		{
			value: HdrDisplayMode.FULL,
			name: t`Full Dynamic Range`,
			desc: t`Display HDR images at full brightness and color range.`,
		},
		{
			value: HdrDisplayMode.STANDARD,
			name: t`Standard Range`,
			desc: t`Tone-map HDR images to standard range, reducing peak brightness.`,
		},
	];
	return (
		<RadioGroup
			options={hdrOptions}
			value={hdrDisplayMode}
			onChange={(value) => {
				AccessibilityCommands.update({hdrDisplayMode: value});
			}}
			aria-label={t`High dynamic range display mode`}
		/>
	);
});
